export default __webpack_public_path__ + "static/media/SI-Vetted-Verified 09 2020.7b87fe75.jpg";